import { defineStore } from 'pinia'
import Axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const SITUACOES_URL = BASE_URL + "api/demandasrepetitivas/situacaoiac"
export const useIacSituacaoStore = defineStore('iacSituacao', {
  state: () => ({ filtered: [], situacoes: [] }),
  getters: {
    all: state => state.situacoes,
  },
  actions: {
    async fetch() {
      const { data } = await Axios.get(SITUACOES_URL)
      const { listaDeSituacoesIac } = data
      this.filtered = this.situacoes = listaDeSituacoesIac
      return listaDeSituacoesIac
    },
  },
})
